var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisaLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 16,
    fill: "none",
    viewBox: "0 0 48 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#10357f",
    d: "m18.353.269-6.335 15.109H7.89L4.78 3.32c-.192-.748-.345-1.017-.921-1.324C2.919 1.478 1.363 1.017 0 .71L.096.27h6.643c.844 0 1.612.557 1.804 1.536l1.651 8.754L14.264.27zm16.184 10.194c.02-3.993-5.51-4.204-5.471-5.99.02-.537.538-1.113 1.651-1.267.557-.077 2.112-.134 3.859.672l.69-3.206A10.4 10.4 0 0 0 31.62 0c-3.859 0-6.585 2.054-6.604 4.992-.02 2.169 1.94 3.398 3.417 4.108 1.517.749 2.035 1.21 2.035 1.881-.019 1.018-1.21 1.46-2.342 1.479-1.958.038-3.11-.538-4.012-.96l-.71 3.302c.921.422 2.591.787 4.338.806 4.109.02 6.796-2.016 6.796-5.145m10.214 4.934h3.609L45.212.288H41.87c-.749 0-1.382.442-1.67 1.113l-5.856 13.996h4.109l.806-2.265h5.01zm-4.377-5.356 2.054-5.683 1.19 5.683zM23.94.269l-3.225 15.109h-3.917L20.024.268z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisaLogo);
export default __webpack_public_path__ + "static/media/visa_logo.cd41e45a2ef2010672aa6660027dae11.svg";
export { ForwardRef as ReactComponent };